import React from "react";

const SecurityAndPrivacy = () => {
  return (
    <div className="min-h-screen bg-black text-white font-secondary">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-primary text-4xl md:text-5xl mb-4">
          Safety & Security
        </h1>
        <p className="text-sm text-[#9fbfc5] mb-6">
          Updated on 1st October, 2025
        </p>
        <p className="text-lg text-[#bfc5c5] mb-8">
          Your trust is not a feature — it’s our foundation.
        </p>

        <section className="mb-8">
          <p className="text-[#d0d6d6] leading-relaxed">
            FOZZIL was born from a promise: intelligence without compromise.
            That means security isn’t added — it’s embedded. We design systems
            so your data stays private, your controls stay yours, and our
            safeguards run continuously.
            <br />
            All infrastructure and runtime services are securely protected by
            <span className="inline-block ml-1 mr-1 px-2 py-1 text-sm font-semibold bg-[#072a3a] text-[#9ff0ff] rounded">
              S.H.A.D.E
            </span>
            — FOZZIL's Secure Hostile Adaptive Defence Engine — a layered
            defence system that detects, isolates, and mitigates advanced
            threats in real time.
          </p>
          <ul className="mt-4 list-disc list-inside text-[#bfc5c5] space-y-2">
            <li>
              Adaptive threat detection with behavioral telemetry and anomaly
              scoring.
            </li>
            <li>Automated isolation and containment to limit blast radius.</li>
            <li>
              Continuous learning from threat intelligence to update defenses in
              real time.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">End-to-End Encryption</h2>
          <p className="text-[#bfc5c5] mb-3">
            All data is encrypted in transit (TLS 1.3) and at rest (AES-256).
            Wherever possible, we employ client-side encryption so that even
            FOZZIL cannot access your plaintext data.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">
            Privacy by Design & Default
          </h2>
          <ul className="list-disc list-inside text-[#bfc5c5] space-y-2">
            <li>
              No data mining; we don’t sell or share your data to third parties.
            </li>
            <li>
              One-click, irreversible data deletion — immediate and auditable.
            </li>
            <li>
              Minimal data retention by default; configurable retention for
              teams and enterprises.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Secure Access</h2>
          <p className="text-[#bfc5c5] mb-3">
            Strong authentication and session controls protect accounts:
          </p>
          <ul className="list-disc list-inside text-[#bfc5c5] space-y-2">
            <li>MFA via authenticator apps, biometrics, or SMS.</li>
            <li>
              Role-based access control for teams and granular permissions.
            </li>
            <li>Auto-logout after 15 minutes of inactivity (configurable).</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Ethical Intelligence</h2>
          <p className="text-[#bfc5c5] mb-3">
            We bake ethics into the stack: real-time bias detection and
            correction, human-in-the-loop for sensitive decisions, and no
            content generation without explicit user consent.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3">Security Contact</h2>
          <p className="text-[#bfc5c5] mb-3">
            Report issues to{" "}
            <a href="mailto:security@fozzil.in" className="underline">
              security@fozzil.in
            </a>
            — we aim to respond within 2 business hours.
          </p>
        </section>

        <blockquote className="border-l-4 border-[#009df2] pl-4 italic text-[#dbe7f2] mb-8">
          “Your data is private. Your trust is sacred.”
        </blockquote>
      </div>
    </div>
  );
};

export default SecurityAndPrivacy;
